// Get version from Vite environment variable
const APP_VERSION = `v ${import.meta.env.VITE_APP_VERSION || '0.0.0'}`;

export const VersionLabel = () => {
  return (
    <div
      className="pointer-events-none fixed bottom-4 left-4 z-50 select-none font-sans text-xs font-medium text-gray-600"
      aria-hidden="true"
    >
      {APP_VERSION}
    </div>
  );
};

export default VersionLabel;
